// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__O5ptX"};